import React from 'react';
import styled from 'styled-components';

import getColor, { HexColor } from 'happytree';

import Button, { Props } from '../Button';
import { disabledStyles } from '../Button.styles';

export type SecondaryButtonProps = Props & {
  bg?: HexColor | 'transparent';
};

const StyledButton = styled(Button)<SecondaryButtonProps>`
  background-color: ${({ bg }) => bg};
  border: 1px solid ${getColor('neutral', 1)};
  transition: border 0.2s;

  ${({ color, isSelected }) =>
    color &&
    `
      color: ${getColor(color, color === 'neutral' ? -3 : 0)};

      &:focus {
        &::after {
          border-color: ${getColor(color)};
        }
      }

      &:active, &:hover {
        border-color: ${getColor(color, 1)};
      }

    ${
      isSelected
        ? ` 
          background-color: ${getColor(color)}; 
          color: ${getColor('background')};
          border: 1px solid ${getColor(color, -1)};
        `
        : ''
    }
  `};

  ${({ isDisabled }) =>
    isDisabled &&
    `
    ${disabledStyles}
    border-color: ${getColor('neutral', 1)};
    
    &:active, &:hover {
      border-color: ${getColor('neutral', 1)};
    }
  `}
`;

const S = {
  SecondaryButton: StyledButton,
};

function SecondaryButton(
  {
    color = 'primary',
    bg = getColor('neutral', 3),
    ...props
  }: SecondaryButtonProps,
  ref: Props['ref'],
) {
  const rippleActiveColor = props.isSelected
    ? getColor(color, color === 'neutral' ? 2 : 0)
    : getColor(color, color === 'neutral' ? 1 : 3);

  const rippleHoverColor = props.isSelected
    ? getColor(color, color === 'neutral' ? 2 : 0)
    : getColor(color, color === 'neutral' ? 2 : 4);

  return (
    <S.SecondaryButton
      ref={ref}
      bg={bg}
      color={color}
      rippleActiveColor={rippleActiveColor}
      rippleHoverColor={rippleHoverColor}
      {...props}
    />
  );
}

export default React.forwardRef(SecondaryButton);
